import React, { useContext, useState } from 'react';
import UPPage from '../components/UPPage';
import { useTranslation } from 'react-i18next';
import { GlobalErrorContext } from '../context';
import { redirect } from '../lib/Utils';
import { ValidatePasswordForm } from '../components/ValidatePasswordForm';
import { ChangePasswordForm } from '../components/ChangePasswordForm';
import { Typography } from '@mui/material';

/**
 * Change password page
 */
export const ChangePassword = () => {
  const { t } = useTranslation('translation');
  const { setGlobalError } = useContext(GlobalErrorContext);

  const [oldPassword, setOldPassword] = useState('');

  return (
    <UPPage>
      <Typography component="h1" variant="h5" align="center">
        {t('changePasswordHeader')}
      </Typography>
      <ValidatePasswordForm
        handleSuccess={setOldPassword}
        handleFailure={() => setGlobalError(t('validatePasswordError'))}
      />
      {oldPassword && (
        <ChangePasswordForm
          oldPassword={oldPassword}
          handleSuccess={() => redirect('/auth/')}
          handleFailure={() => setGlobalError(t('changePasswordError'))}
        />
      )}
    </UPPage>
  );
};
